import classnames from 'classnames';
import Icon from 'components/ui/icon';
import './overallChip.scss';

interface Props {
  value: number;
}

export const OverallChip: React.FC<Props> = ({ value }) => {
  return (
    <div
      className={classnames('flex items-center gap-[2px] rounded-[54px] p-[3px] px-[10px]', {
        'overall-chip_increase': value > 0,
        'overall-chip_decrease': value < 0,
      })}>
      <Icon
        name={value > 0 ? 'arrowUp' : 'arrowDown'}
        className='overall-chip__icon w-[12px] h-[10px]'
        size={9}
      />
      <span className='text-sm-medium leading-[20px]'>{Math.abs(value)}%</span>
    </div>
  );
};
